export default {
    title: 'Publish via link',
    infoText: 'Share your innovation projects publicly with other people. They do not need access to the Trendmanager.'
}
